import React, { Component } from "react";
import { Header } from "./layout/Header";
import { Footer } from "./layout/Footer";
import VulnerabilityScanForm from "./pages/VulnerabilityScanForm";

export class Home extends Component {
  render() {
    return (
      <div className="site-main height-overflow-css">
        <Header />
        <VulnerabilityScanForm />
        <Footer />
      </div>
    );
  }
}

export default Home;
